import { AbstractClient, CompositionClient } from "@/app/client";
import { UUID } from "crypto";
import {
  LocationCreate,
  LocationUpdate,
  LocationResponse,
  LocationFilter,
} from "../types/location";

export default class APILocations extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  // Create a new location
  create = async (locationData: LocationCreate): Promise<LocationResponse> => {
    let res = await this._fetch({
      url: `/locations/`,
      method: "POST",
      body: locationData,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Get locations list with filtering
  list = async (filter?: LocationFilter): Promise<LocationResponse[]> => {
    let params: any = {};
    if (filter) {
      if (filter.is_active !== undefined) params.active_only = filter.is_active;
    }

    let res = await this._fetch({
      url: `/locations/`,
      method: "GET",
      params,
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Get a single location by ID
  get = async (locationId: UUID): Promise<LocationResponse> => {
    let res = await this._fetch({
      url: `/locations/${locationId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Update a location
  update = async (
    locationId: UUID,
    locationData: LocationUpdate,
  ): Promise<LocationResponse> => {
    let res = await this._fetch({
      url: `/locations/${locationId}`,
      method: "PUT",
      body: locationData,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  // Delete a location
  delete = async (locationId: UUID): Promise<void> => {
    await this._fetch({
      url: `/locations/${locationId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
  };
}
